import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';

interface PrivacyPolicyProps {
    language?: string;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ language = 'en' }) => {
    const [htmlContent, setHtmlContent] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchHtmlContent = async () => {
            try {
                // Determine which file to load based on the language parameter
                const isGerman = language.startsWith('de');
                const filePath = `/templates/privacy-policy/privacy-policy-${isGerman ? 'de' : 'en'}.html`;

                const response = await fetch(filePath);
                const html = await response.text();
                setHtmlContent(html);
                setLoading(false);
            } catch (error) {
                console.error('Error loading privacy policy:', error);
                setLoading(false);
            }
        };

        fetchHtmlContent();
    }, [language]); // Re-fetch when language changes

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ padding: 4 }}>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </Box>
    );
};

export default PrivacyPolicy;
